import { Link } from "react-router-dom";

const footerSections = [
  {
    title: "内容频道",
    links: [
      { label: "最新资讯", to: "/news" },
      { label: "作品库", to: "/works" },
      { label: "角色分析", to: "/characters" },
      { label: "站内搜索", to: "/search" },
    ],
  },
  {
    title: "热门标签",
    links: [
      { label: "原创动画", to: "/works" },
      { label: "剧场版推荐", to: "/works" },
      { label: "治愈日常", to: "/works" },
      { label: "国创观察", to: "/news" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "运营团队", to: "/about" },
      { label: "意见反馈", to: "/about" },
      { label: "版权声明", to: "/about" },
    ],
  },
];

const friendlyLinks = ["次元观测站", "动画产业观察", "声优情报局", "手绘分镜研究室", "同人创作社区"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-accent-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
                a
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">
                age<span className="text-primary-400">动漫</span>
              </span>
            </Link>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-sm">
              age动漫专注动漫资讯与优秀作品的内容整理，为动漫爱好者提供行业动态、作品介绍、角色解析与观番推荐。我们相信，好的内容值得被慢慢读完。
            </p>
            <div className="flex flex-wrap items-center gap-2 mt-5">
              <span className="text-[11px] text-background-300/70 mr-1">友情链接</span>
              {friendlyLinks.map((name) => (
                <Link
                  key={name}
                  to="/about"
                  className="text-[11px] px-2 py-1 rounded bg-background-50/10 text-background-200 hover:bg-background-50/20 transition-colors cursor-pointer"
                >
                  {name}
                </Link>
              ))}
            </div>
          </div>
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-3">{section.title}</h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={`${section.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/70 leading-relaxed">
            © 2026 age动漫 · 本站内容用于内容展示与浏览体验验证，作品与人物均为演示数据，不构成任何商业推荐。
          </p>
          <p className="text-xs text-background-300/70 flex items-center gap-1.5">
            <i className="ri-computer-line"></i>
            建议使用最新版浏览器浏览 · 支持桌面与移动端
          </p>
        </div>
      </div>
    </footer>
  );
}